import { Component, OnInit } from '@angular/core';

@Component({
  selector: 's2a-insight',
  templateUrl: './insight.component.html',
  styleUrls: ['./insight.component.scss']
})
export class InsightComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
